import { useFormContext } from 'react-hook-form'

import {
  FeatureFlagsSchemaObjectEntry,
  FeatureFlagValue,
  GenericFeatureFlags,
} from 'domains/featureFlags'
import { getValueByPath } from 'utils/getValueByPath'

import { DefaultObjectContainer } from '../components/DefaultObjectContainer'
import { FeatureFlagListContainer } from '../components/FeatureFlagListContainer'

import { FeatureFlagItem } from './FeatureFlagItem'

interface FeatureFlagObjectProps {
  path: string[]
  ffSchemaObject: FeatureFlagsSchemaObjectEntry
  dbFFObject?: GenericFeatureFlags
  nested?: boolean
}

export const FeatureFlagObject = ({
  path = [],
  ffSchemaObject,
  dbFFObject = {},
  nested,
}: FeatureFlagObjectProps) => {
  const form = useFormContext<GenericFeatureFlags>()

  if (ffSchemaObject.dependentOn && !form.watch(ffSchemaObject.dependentOn)) {
    return null
  }

  const visibleProperties = Object.entries(ffSchemaObject.properties).filter(
    (entry) => entry[1].visible,
  )

  // Skips visual nesting if no props or a single nested prop
  const skipFfLevel =
    visibleProperties.length === 0 ||
    (visibleProperties.length === 1 && visibleProperties[0][1].title === ffSchemaObject.title)

  const flagMapObject = ffSchemaObject.type === 'object' && ffSchemaObject.flagMap
  const ObjectContainer = flagMapObject ? FeatureFlagListContainer : DefaultObjectContainer

  return (
    <ObjectContainer title={!skipFfLevel ? ffSchemaObject.title : ''} nested={nested}>
      {visibleProperties.map((entry) => {
        const ffKey = entry[0]
        const ffData = entry[1]

        return ffData.type === 'object' ? (
          <FeatureFlagObject
            key={ffKey}
            path={[...path, ffKey]}
            ffSchemaObject={ffData}
            dbFFObject={getValueByPath(dbFFObject, ffKey) as GenericFeatureFlags}
            nested={!skipFfLevel}
          />
        ) : (
          <FeatureFlagItem
            key={ffKey}
            path={[...path, ffKey].join('.')}
            ffSchemaItem={ffData}
            dbFFItem={getValueByPath(dbFFObject, ffKey) as FeatureFlagValue | FeatureFlagValue[]}
            nested={!skipFfLevel && !flagMapObject}
          />
        )
      })}
    </ObjectContainer>
  )
}
